/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} webReservationsUouActionSaveParams
* @property {string} actionName - unique action name
* @property {string} additionalDetails - JSON with custom reservation settings inputs
* @property {boolean} agreeToTou - true/false
* @property {boolean} emailMarketing - true/false
* @property {GUID} locationGuid - restaurant location ID
* @property {string} origin - widget / page
* @property {number} partySize - num of reserved sits
* @property {GUID} reservationId - reservation ID
* @property {string} screenName - unique screen name
* @property {DateTime} selectedTimeslot - reserved date/time slot
* @property {boolean} smsMarketing - true/false
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.UoU.ActionSave. Evid: 1503.
 * Event description: Actions in UoU Web flow..

 * actionName - Type: string. Desc: unique action name
 *
 * additionalDetails - Type: string. Desc: JSON with custom reservation settings inputs
 *
 * agreeToTou - Type: bool. Desc: true/false
 *
 * emailMarketing - Type: bool. Desc: true/false
 *
 * locationGuid - Type: guid. Desc: restaurant location ID
 *
 * origin - Type: string. Desc: widget / page
 *
 * partySize - Type: numeric. Desc: num of reserved sits
 *
 * reservationId - Type: guid. Desc: reservation ID
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * selectedTimeslot - Type: datetime. Desc: reserved date/time slot
 *
 * smsMarketing - Type: bool. Desc: true/false
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUouActionSaveParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUouActionSave = function (params) {
    return { evid: 1503, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationSettingsNotificationsClicksParams
* @property {string} buttonType - notifications you get/notifications you send
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > settings > notifications > clicks. Evid: 1505.
 * Event description: when user clicks on buttons on notifications page.

 * buttonType - Type: string. Desc: notifications you get/notifications you send
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationSettingsNotificationsClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationSettingsNotificationsClicks = function (params) {
    return { evid: 1505, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouStartOfReservationFunnelClickOnFindATableParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {DateTime} datetime - -
* @property {boolean} isAddOn - true if its a click from the add on and false if not
* @property {boolean} isMultiLocation - -
* @property {GUID} locationGuid - -
* @property {GUID} memberId - -
* @property {string} origin - previe_mode/live_site_mode
* @property {number} partySize - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {GUID} visitorId - -
**/
/**
 * Name: Table reservation > uou > start of reservation funnel > click on find a table. Evid: 1506.
 * Event description: clicks of uou in the beginning of the funnel.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * datetime - Type: datetime. Desc: -
 *
 * isAddOn - Type: bool. Desc: true if its a click from the add on and false if not
 *
 * isMultiLocation - Type: bool. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * memberId - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: previe_mode/live_site_mode
 *
 * partySize - Type: numeric. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * visitorId - Type: guid. Desc: -
 * @param {tableReservationUouStartOfReservationFunnelClickOnFindATableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouStartOfReservationFunnelClickOnFindATable = function (params) {
    return { evid: 1506, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouReserveNowErrorParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {string} errorType - no _slot_chosen / parameter_validation_error / no_premium_or_toggle_off/no_location
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} origin - preview_mode/live_site_mode
* @property {number} partySize - -
* @property {DateTime} requestedDate - -
* @property {DateTime} requestedTime - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > reserve now error -. Evid: 1512.
 * Event description: when uou is clicking on “reserve now” but there is actually this error.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * errorType - Type: string. Desc: no _slot_chosen / parameter_validation_error / no_premium_or_toggle_off/no_location
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: preview_mode/live_site_mode
 *
 * partySize - Type: numeric. Desc: -
 *
 * requestedDate - Type: datetime. Desc: -
 *
 * requestedTime - Type: datetime. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouReserveNowErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouReserveNowError = function (params) {
    return { evid: 1512, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouReservationFunnelClickOnASlotParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {DateTime} dateSlot - the date of the chosen slot
* @property {GUID} locationGuid - -
* @property {GUID} memberId - -
* @property {number} numLocations - -
* @property {string} origin - preview_mode/ live_site_mode
* @property {number} partySize - -
* @property {DateTime} requested_Date - -
* @property {DateTime} requestedTime - -
* @property {string} restId - -
* @property {string} timeSlot - the chosen hour
* @property {GUID} visitorId - -
**/
/**
 * Name: Table reservation > uou > reservation funnel > click on a slot. Evid: 1510.
 * Event description: when uou click ion specific slot.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * dateSlot - Type: datetime. Desc: the date of the chosen slot
 *
 * locationGuid - Type: guid. Desc: -
 *
 * memberId - Type: guid. Desc: -
 *
 * numLocations - Type: numeric. Desc: -
 *
 * origin - Type: string. Desc: preview_mode/ live_site_mode
 *
 * partySize - Type: numeric. Desc: -
 *
 * requested_Date - Type: datetime. Desc: -
 *
 * requestedTime - Type: datetime. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * timeSlot - Type: string. Desc: the chosen hour
 *
 * visitorId - Type: guid. Desc: -
 * @param {tableReservationUouReservationFunnelClickOnASlotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouReservationFunnelClickOnASlot = function (params) {
    return { evid: 1510, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} webReservationsUouButtonClickParams
* @property {string} buttonName - unique button name
* @property {string} origin - widget / page
* @property {GUID} reservationId - reservation ID
* @property {string} screenName - unique screen name
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.UoU.ButtonClick. Evid: 1501.
 * Event description: Button Clicks in UoU Web flow..

 * buttonName - Type: string. Desc: unique button name
 *
 * origin - Type: string. Desc: widget / page
 *
 * reservationId - Type: guid. Desc: reservation ID
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUouButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUouButtonClick = function (params) {
    return { evid: 1501, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouClickOnReserveNowParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} origin - preview_mode/live_site_mode
* @property {number} partySize - -
* @property {DateTime} requestedDate - -
* @property {DateTime} requestedTime - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > click on reserve now. Evid: 1524.
 * Event description: when uou is clicking on “reserve now”.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: preview_mode/live_site_mode
 *
 * partySize - Type: numeric. Desc: -
 *
 * requestedDate - Type: datetime. Desc: -
 *
 * requestedTime - Type: datetime. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouClickOnReserveNowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouClickOnReserveNow = function (params) {
    return { evid: 1524, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouReservationFunnelSlotsListIsLoadedParams
* @property {string} contactId - -
* @property {boolean} isRequestedDateAvailable - true if the requested date is available and false if it offer other dates
* @property {boolean} isRequestedTimeAvailable - true if it’s available
* @property {GUID} locationGuid - -
* @property {GUID} memberId - -
* @property {number} numLocations - -
* @property {number} partySize - -
* @property {DateTime} requestedDate - -
* @property {DateTime} requestedTime - -
* @property {string} restId - -
* @property {GUID} visitorId - -
**/
/**
 * Name: Table reservation > uou > reservation funnel > slots list is loaded. Evid: 1509.
 * Event description: when the list of slots is loaded to the uou.

 * contactId - Type: string. Desc: -
 *
 * isRequestedDateAvailable - Type: bool. Desc: true if the requested date is available and false if it offer other dates
 *
 * isRequestedTimeAvailable - Type: bool. Desc: true if it’s available
 *
 * locationGuid - Type: guid. Desc: -
 *
 * memberId - Type: guid. Desc: -
 *
 * numLocations - Type: numeric. Desc: -
 *
 * partySize - Type: numeric. Desc: -
 *
 * requestedDate - Type: datetime. Desc: -
 *
 * requestedTime - Type: datetime. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * visitorId - Type: guid. Desc: -
 * @param {tableReservationUouReservationFunnelSlotsListIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouReservationFunnelSlotsListIsLoaded = function (params) {
    return { evid: 1509, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouReservationNotFoundModalLoadedParams
* @property {string} contactId - -
* @property {GUID} locationGuid - -
* @property {number} reservationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > reservation not found modal loaded. Evid: 1522.
 * Event description: when reservation not found.

 * contactId - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * reservationId - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouReservationNotFoundModalLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouReservationNotFoundModalLoaded = function (params) {
    return { evid: 1522, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} webReservationsUouErrorTypeParams
* @property {string} errorType - unique error name
* @property {GUID} locationGuid - restaurant location ID
* @property {string} origin - null
* @property {GUID} reservationId - reservation ID
* @property {string} screenName - unique screen name
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.UoU.ErrorType. Evid: 1504.


 * errorType - Type: string. Desc: unique error name
 *
 * locationGuid - Type: guid. Desc: restaurant location ID
 *
 * origin - Type: string.
 *
 * reservationId - Type: guid. Desc: reservation ID
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUouErrorTypeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUouErrorType = function (params) {
    return { evid: 1504, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouTryToClickOnUnavailableTimeslotParams
* @property {GUID} chosenUnavailableDate - -
* @property {DateTime} chosenUnavailableTime - -
* @property {string} contactId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {number} partySize - -
* @property {DateTime} requestedDate - -
* @property {DateTime} requestedTime - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou >  Try to click on unavailable timeslot. Evid: 1513.
 * Event description: when uou is clicking on “reserve now” but there is actually this error.

 * chosenUnavailableDate - Type: guid. Desc: -
 *
 * chosenUnavailableTime - Type: datetime. Desc: -
 *
 * contactId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * partySize - Type: numeric. Desc: -
 *
 * requestedDate - Type: datetime. Desc: -
 *
 * requestedTime - Type: datetime. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouTryToClickOnUnavailableTimeslotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouTryToClickOnUnavailableTimeslot = function (params) {
    return { evid: 1513, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouEndOfReservationProcessJumpingMessagesParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} messageType - out_of_time / table_no_longer_exist/ somthing_went_wrong
* @property {number} numMandatoryFieldsFull - -
* @property {string} origin - live_site_mode / preview_mode
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > end of reservation process > jumping messages. Evid: 1516.
 * Event description: when the message of out of time is jumping to the uou.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * messageType - Type: string. Desc: out_of_time / table_no_longer_exist/ somthing_went_wrong
 *
 * numMandatoryFieldsFull - Type: numeric. Desc: -
 *
 * origin - Type: string. Desc: live_site_mode / preview_mode
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouEndOfReservationProcessJumpingMessagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouEndOfReservationProcessJumpingMessages = function (params) {
    return { evid: 1516, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouThankYouPageClicksParams
* @property {string} buttonName - cancel / add_to_calendar /back_to_home_page
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} origin - preview_mode/live_site_mode
* @property {number} reservationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > thank you page > clicks. Evid: 1519.
 * Event description: thank you page > clicks.

 * buttonName - Type: string. Desc: cancel / add_to_calendar /back_to_home_page
 *
 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: preview_mode/live_site_mode
 *
 * reservationId - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouThankYouPageClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouThankYouPageClicks = function (params) {
    return { evid: 1519, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouShowMoreLessParams
* @property {string} buttonName - show_more_available_dates / show_more_text / show_less_text
* @property {string} contactId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {number} numLocations - -
* @property {number} partySize - -
* @property {boolean} requestedDateAvilable - tru/false
* @property {boolean} requestedTimeAvailable - tru/false
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > show more/less. Evid: 1511.
 * Event description: when uou clicks on the button of show more/less information.

 * buttonName - Type: string. Desc: show_more_available_dates / show_more_text / show_less_text
 *
 * contactId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * numLocations - Type: numeric. Desc: -
 *
 * partySize - Type: numeric. Desc: -
 *
 * requestedDateAvilable - Type: bool. Desc: tru/false
 *
 * requestedTimeAvailable - Type: bool. Desc: tru/false
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouShowMoreLessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouShowMoreLess = function (params) {
    return { evid: 1511, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouEndOfReservationProcessErroModalsParams
* @property {string} buttonName - x button / find_new_table
* @property {string} contactId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {string} messageType - out_of_time / table_no_longer_exist/ somthing_went_wrong
* @property {number} numMandatoryFieldsFull - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > end of reservation process > error_modals. Evid: 1517.
 * Event description: when the message of out of time is jumping to the uou.

 * buttonName - Type: string. Desc: x button / find_new_table
 *
 * contactId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * messageType - Type: string. Desc: out_of_time / table_no_longer_exist/ somthing_went_wrong
 *
 * numMandatoryFieldsFull - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouEndOfReservationProcessErroModalsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouEndOfReservationProcessErroModals = function (params) {
    return { evid: 1517, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouThankYouPageIsLoadedParams
* @property {string} areaCode - -
* @property {string} contactId - -
* @property {DateTime} dateTimeValue - -
* @property {string} emailAddress - -
* @property {string} first_name - -
* @property {GUID} instanceId - -
* @property {string} last_name - -
* @property {GUID} locationGuid - -
* @property {string} mailCheckbox - check/uncheck
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {number} reservationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > thank you page is loaded. Evid: 1518.
 * Event description: thank you page is loaded.

 * areaCode - Type: string. Desc: -
 *
 * contactId - Type: string. Desc: -
 *
 * dateTimeValue - Type: datetime. Desc: -
 *
 * emailAddress - Type: string. Desc: -
 *
 * first_name - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * last_name - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * mailCheckbox - Type: string. Desc: check/uncheck
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservationId - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouThankYouPageIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouThankYouPageIsLoaded = function (params) {
    return { evid: 1518, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouReservationCancellationPageIsLoadedParams
* @property {string} areaCode - -
* @property {string} contactId - -
* @property {DateTime} dateTimeValue - -
* @property {string} emailAddress - -
* @property {string} first_name - -
* @property {GUID} instanceId - -
* @property {string} last_name - -
* @property {GUID} locationGuid - -
* @property {string} mailCheckbox - check/uncheck
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {number} reservationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > reservation cancellation page is loaded. Evid: 1521.
 * Event description: reservation cancellation page is loaded.

 * areaCode - Type: string. Desc: -
 *
 * contactId - Type: string. Desc: -
 *
 * dateTimeValue - Type: datetime. Desc: -
 *
 * emailAddress - Type: string. Desc: -
 *
 * first_name - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * last_name - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * mailCheckbox - Type: string. Desc: check/uncheck
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservationId - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouReservationCancellationPageIsLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouReservationCancellationPageIsLoaded = function (params) {
    return { evid: 1521, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouStartOfReservationFunnelReservationPageWidgetISloadedParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {boolean} isAddOn - true if its a click from the add on and false if not
* @property {boolean} isMultiLocation - -
* @property {GUID} locationGuid - -
* @property {GUID} memberId - -
* @property {string} origin - previe_mode/live_site_mode
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
* @property {string} type - page/widget
* @property {GUID} visitorId - -
**/
/**
 * Name: Table reservation > uou > start of reservation funnel > reservation page/widget i sloaded. Evid: 1525.
 * Event description: when the uou see this page/widget.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * isAddOn - Type: bool. Desc: true if its a click from the add on and false if not
 *
 * isMultiLocation - Type: bool. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * memberId - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: previe_mode/live_site_mode
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * type - Type: string. Desc: page/widget
 *
 * visitorId - Type: guid. Desc: -
 * @param {tableReservationUouStartOfReservationFunnelReservationPageWidgetISloadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouStartOfReservationFunnelReservationPageWidgetISloaded = function (params) {
    return { evid: 1525, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouBeforeReservationFunnelStartsClickOnBookATableParams
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {boolean} isMultiLocation - -
* @property {GUID} locationGuid - -
* @property {GUID} memberId - -
* @property {string} origin - preview_mode/ live_site_mode
* @property {string} restId - -
* @property {GUID} visitorId - -
**/
/**
 * Name: Table reservation > uou > before reservation funnel starts> click on book a table (shortcut button). Evid: 1507.
 * Event description: clicks of uou in the beginning of the funnel.

 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * isMultiLocation - Type: bool. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * memberId - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: preview_mode/ live_site_mode
 *
 * restId - Type: string. Desc: -
 *
 * visitorId - Type: guid. Desc: -
 * @param {tableReservationUouBeforeReservationFunnelStartsClickOnBookATableParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouBeforeReservationFunnelStartsClickOnBookATable = function (params) {
    return { evid: 1507, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouLeavingPageInTheMiddleOfTheFlowParams
* @property {string} actionType - modal loaded/ click
* @property {string} buttonName - x/stay_on_page / leave_page / external_click (when the uou click outside of the modal)
* @property {string} contactId - -
* @property {GUID} locationGuid - -
* @property {number} reservationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > leaving page in the middle of the flow. Evid: 1523.
 * Event description: when uou is leaving the page in the middle of the reservation flow.

 * actionType - Type: string. Desc: modal loaded/ click
 *
 * buttonName - Type: string. Desc: x/stay_on_page / leave_page / external_click (when the uou click outside of the modal)
 *
 * contactId - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * reservationId - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouLeavingPageInTheMiddleOfTheFlowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouLeavingPageInTheMiddleOfTheFlow = function (params) {
    return { evid: 1523, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouFieldsAndButtonsEngagementParams
* @property {string} actionType - click/start typing / check / uncheck
* @property {string} buttonName - first_name / last_name / area_code/phone_number/ email_adress/agree_recieve_emails
* @property {string} contactId - -
* @property {string} correlationId - -
* @property {GUID} instanceId - -
* @property {boolean} isMandatory - true/false
* @property {GUID} locationGuid - -
* @property {string} origin - preview_mode/live_site_mode
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > fields and buttons engagement. Evid: 1514.
 * Event description: when the uou clicks on the one of the fields or start typing his details..

 * actionType - Type: string. Desc: click/start typing / check / uncheck
 *
 * buttonName - Type: string. Desc: first_name / last_name / area_code/phone_number/ email_adress/agree_recieve_emails
 *
 * contactId - Type: string. Desc: -
 *
 * correlationId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * isMandatory - Type: bool. Desc: true/false
 *
 * locationGuid - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: preview_mode/live_site_mode
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouFieldsAndButtonsEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouFieldsAndButtonsEngagement = function (params) {
    return { evid: 1514, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/*event 1500 on project 'com.wixpress.table-reservations-web-uou' has no function name set, please set one in BI Catalog.*/
/**
* @typedef {Object} webReservationsUouScreenOpenParams
* @property {string} origin - widget / page
* @property {string} screenName - unique screen name
* @property {string} userEntry - BM / preview / site
**/
/**
 * Name: Web.Reservations.UoU.ScreenOpen. Evid: 1502.
 * Event description: Screen Open events in UoU Web flows..

 * origin - Type: string. Desc: widget / page
 *
 * screenName - Type: string. Desc: unique screen name
 *
 * userEntry - Type: string. Desc: BM / preview / site
 * @param {webReservationsUouScreenOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var webReservationsUouScreenOpen = function (params) {
    return { evid: 1502, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouCancellationReservationModalEngagementParams
* @property {string} actionType - modal loaded / click
* @property {string} buttonType - no_keep_it / yes_cancel_reservation / X_button
* @property {string} contactId - -
* @property {GUID} instanceId - -
* @property {GUID} locationGuid - -
* @property {number} reservationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > cancellation reservation modal engagement. Evid: 1520.
 * Event description: when the cancelation reservation modal is loseded or has been engaged by the you (clicks).

 * actionType - Type: string. Desc: modal loaded / click
 *
 * buttonType - Type: string. Desc: no_keep_it / yes_cancel_reservation / X_button
 *
 * contactId - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * reservationId - Type: numeric. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouCancellationReservationModalEngagementParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouCancellationReservationModalEngagement = function (params) {
    return { evid: 1520, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouClickOnCompleteReservationParams
* @property {string} areaCode - -
* @property {string} contactId - -
* @property {DateTime} dateTimeValue - of the reservation
* @property {string} email - -
* @property {string} firstName - -
* @property {GUID} instanceId - -
* @property {string} lastName - -
* @property {GUID} locationGuid - -
* @property {string} mailCheckbox - check/uncheck
* @property {number} numInvaldFields - -
* @property {number} numValidFields - -
* @property {string} origin - -
* @property {number} partySize - -
* @property {string} phoneNumber - -
* @property {GUID} reservationLocationId - -
* @property {string} restId - -
**/
/**
 * Name: Table reservation > uou > click on complete reservation. Evid: 1515.
 * Event description: click on complete reservation -  in order to make sure that reservations was done use condition - "num_invalid_fields = 0".

 * areaCode - Type: string. Desc: -
 *
 * contactId - Type: string. Desc: -
 *
 * dateTimeValue - Type: datetime. Desc: of the reservation
 *
 * email - Type: string. Desc: -
 *
 * firstName - Type: string. Desc: -
 *
 * instanceId - Type: guid. Desc: -
 *
 * lastName - Type: string. Desc: -
 *
 * locationGuid - Type: guid. Desc: -
 *
 * mailCheckbox - Type: string. Desc: check/uncheck
 *
 * numInvaldFields - Type: numeric. Desc: -
 *
 * numValidFields - Type: numeric. Desc: -
 *
 * origin - Type: string. Desc: -
 *
 * partySize - Type: numeric. Desc: -
 *
 * phoneNumber - Type: string. Desc: -
 *
 * reservationLocationId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 * @param {tableReservationUouClickOnCompleteReservationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouClickOnCompleteReservation = function (params) {
    return { evid: 1515, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
/**
* @typedef {Object} tableReservationUouOnlineReservationsAreUnavailableModalIsJumpingParams
* @property {string} contactId - -
* @property {boolean} isAddOn - true if its from add on flow, false otherwise
* @property {boolean} isMultiLocation - -
* @property {boolean} isRestPhoneNum - is the restaurant has phone number on the modal?
* @property {GUID} locationGuid - -
* @property {GUID} memberId - -
* @property {string} restId - -
* @property {string} unavailableReason - toggle_off/around_dates/ around_selected_time / large_party
* @property {GUID} visitorId - -
**/
/**
 * Name: Table reservation > uou > online reservations are unavailable modal is jumping. Evid: 1508.
 * Event description: clicks of uou in the beginning of the funnel.

 * contactId - Type: string. Desc: -
 *
 * isAddOn - Type: bool. Desc: true if its from add on flow, false otherwise
 *
 * isMultiLocation - Type: bool. Desc: -
 *
 * isRestPhoneNum - Type: bool. Desc: is the restaurant has phone number on the modal?
 *
 * locationGuid - Type: guid. Desc: -
 *
 * memberId - Type: guid. Desc: -
 *
 * restId - Type: string. Desc: -
 *
 * unavailableReason - Type: string. Desc: toggle_off/around_dates/ around_selected_time / large_party
 *
 * visitorId - Type: guid. Desc: -
 * @param {tableReservationUouOnlineReservationsAreUnavailableModalIsJumpingParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tableReservationUouOnlineReservationsAreUnavailableModalIsJumping = function (params) {
    return { evid: 1508, src: 61, endpoint: 'table-reservations-web-uou', params: params };
};
//# sourceMappingURL=index.js.map